import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const CountryInternalFlightVATRateRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings--country-internal-flight-vat-rate']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
